import $ from "jquery";
import { csl, u_ } from "@pressmedia/webappbase";

// ファイルアップローダの設定
export default {
	vuwType: "fileUploader",
	stack: [],
	
	_sendRequest() {
		return this.container.getForm()._sendRequest.apply(this, arguments);
	},
	
	_aSubmitLegacy() {
		return this.container.getForm()._aSubmitLegacy.apply(this, arguments);
	},
	
	begin($form, opt, vuwFileUploader) {
		if( u_.isFunction(this.container.uploadCallbacks.begin) ) {
			this.container.uploadCallbacks.begin.apply(
				this.container,
				u_.getAsArray(arguments).concat(this)
			);
		}
	},
	
	onError(error) {
		// サーバーエラー（errorがオブジェクト）の場合、記憶したカーソル位置を削除する
		u_.isObject(error) && this.stack.shift();
		
		if( u_.isFunction(this.container.uploadCallbacks.onError) ) {
			this.container.uploadCallbacks.onError.apply(this.container, arguments);
		}
		
		// refresh file input.
		this.refresh();
	},
	
	onSelect(selectedFilePath, selectedFileName) {
		// 現在のカーソル位置を記憶しておく
		const quill = this.container.quill;
		quill.hasFocus() || quill.focus();
		this.stack.push( quill.getSelection() );
		
		if( u_.isFunction(this.container.uploadCallbacks.onSelect) ) {
			this.container.uploadCallbacks.onSelect.apply(
				this.container,
				u_.getAsArray(arguments)
			);
		}
	},
	
	onDisSelect(paramKey) {
		if( u_.isFunction(this.container.uploadCallbacks.onDisSelect) ) {
			this.container.uploadCallbacks.onDisSelect.apply(this.container, arguments);
		}
	},
	
	onFileRead(ulFile, content) {
		if( u_.isFunction(this.container.uploadCallbacks.onFileRead) ) {
			this.container.uploadCallbacks.onFileRead.apply(this.container, arguments);
		}
	},
	
	onUpload(res) {
		let range = this.stack.shift();
		const quill = this.container.quill;
		
		if( !u_.isObject(range) ) {
			quill.hasFocus() || quill.focus();
			range = quill.getSelection();
		}
		
		const keys = [this.container.paramKey, this.dataType];
		
		if(
			u_.isObject(range) &&
			u_.isObject(res.keep) &&
			u_.isObject(res.keep[ keys[0] ]) &&
			res.keep[ keys[0] ][ keys[1] ]
		) {
			const fpath = [
				this.container.config.fileDir,
				res.dir,
				res.keep[ keys[0] ][ keys[1] ]
			].join("/");
			
			range.current = quill.getSelection() || range;
			
			switch(this.dataType) {
				case "img": {
					quill.insertEmbed(range.index, "image", fpath, "user");
					
					// pending untill embed img is loaded.
					this.container._promise = Promise.all([
						this.container._promise,
						
						new Promise(resolve => {
							const $img = $(quill.container).find(`img[src='${fpath}']`).attr({
								alt: this.currentFileName
							});
							const img = $img.get(0);
							
							const timer = setTimeout(resolve, 30000);
							img.onload = () => {
								$img.attr("data-loaded", "1");
								clearTimeout(timer);
								resolve();
							};
							
							img.error = () => {
								clearTimeout(timer);
								resolve();
							};
							
							img.complete && $img.trigger(!img.height ? "error" : "load", [true]);
						})
					]);
					
					if(range.current.index === range.index) {
						quill.setSelection(range.index + 1, 0);
					}
				} break;
				
				default: {
					if(range.length) {
						quill.setSelection(range.index, range.length);
						quill.format("link", fpath, "user");
						
						if(
							range.current.index !== range.index ||
							range.current.length !== range.length
						) {
							quill.setSelection(range.current.index, range.current.length);
						}
						
					} else {
						quill.insertText(range.index, this.currentFileName, "link", fpath, "user");
						
						if(range.current.index === range.index) {
							quill.setSelection(range.index, this.currentFileName.length);
						}
					}
				} break;
			}
			
		} else {
			csl.warn("onUpload", `${["keep"].concat(keys).join(".")} is not found.`, res.keep);
		}
		
		if( u_.isFunction(this.container.uploadCallbacks.onUpload) ) {
			this.container.uploadCallbacks.onUpload.apply(this.container, arguments);
		}
		
		// for refresh error prompt
		this.container.$self.trigger("change", [true]);
		
		// refresh file input.
		this.refresh();
	}
};
